// extracted by mini-css-extract-plugin
export default {"fullscreen-button":"FullscreenToggle--fullscreen-button--rKS6Q","fullscreenButton":"FullscreenToggle--fullscreen-button--rKS6Q"};